import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CloseIconButton from "components/CloseIconButton";
import { QrCodeIcon } from "@heroicons/react/24/solid";
import { ModalProps } from "../types";
import { useHistory } from "react-router-dom";
import SearchInput2 from "components/SearchInput2";

export const EmpProducerCodesModal: React.FC<ModalProps> = ({
  employeeId,
  prodCodeData,
  showFullView,
  closeFullView,
}) => {
  const history = useHistory();

  // Search FIlter
  const [isSearch, setIsSearch] = useState(false);
  const [filteredProdCode, setFilteredProdCode] = useState<any[]>([]);
  const [searchInputField, setSearchInputField] = useState("");

  const handleClearButton = () => {
    setFilteredProdCode([]);
    setIsSearch(false);
    handleSearchProdCode("");
    setSearchInputField("");
  };

  const handleSearchProdCode = (target) => {
    setFilteredProdCode(
      prodCodeData?.filter(
        (x) =>
          (x.carrierName ?? "").toLowerCase().includes(target.toLowerCase()) ||
          (x.producerCode ?? "").toLowerCase().includes(target.toLowerCase())
      )
    );
  };

  const handleHyperlink = (x) => {
    localStorage.setItem("employeeId", employeeId);
    localStorage.setItem("fromModal", "true");

    history.push({
      pathname: "/carrieragreementmgmt/producercodeconfig",
      state: {
        masterCarrierId: x.carrierId,
        carrierProducerCodeId: x.carrierProducerCodeId,
        action: "CarrierProducerCode",
      },
    });

    window.location.reload();
  };

  return (
    <>
      <Transition appear show={showFullView} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-20 overflow-y-auto bg-black bg-opacity-40 py-10"
          onClose={() => {}}
        >
          <div className="min-h-full text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>
            <span
              className="inline-block h-screen align-middle overflow-auto"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="sm:w-4/5 md:w-7/5 lg:w-10/12 inline-block border-quinary border-l-4 px-4 pb-3 pt-2 text-left align-middle transition-all 
                  transform bg-white shadow-xl brContainer relative"
              >
                <div className="flex items-center space-x-2 pb-2 border-b-2 border-secondary">
                  <div>
                    <QrCodeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                  </div>
                  <div className="flex flex-row items-center space-x-2 text-sm ">
                    <div className="font-medium">Producer Codes Appointed </div>
                  </div>
                </div>

                <div className="w-full borderContainer p-2 bg-white px-9">
                  <div className="py-2 grid grid-cols-6 gap-1">
                    <div className="text-xs col-start-1 col-end-2 flex flex-row">
                      <SearchInput2
                        className="border-b"
                        placeholder="Search"
                        id="searchFilter"
                        value={searchInputField}
                        onChange={(e) => {
                          setSearchInputField(e.target.value);
                          handleSearchProdCode(e.target.value);
                          e.target.value === ""
                            ? setIsSearch(false)
                            : setIsSearch(true);
                        }}
                        onSelectionChange={() => {}}
                      />
                      <button
                        className="opacity-50 -ml-3"
                        onClick={() => handleClearButton()}
                      >
                        X
                      </button>
                    </div>
                  </div>
                  <div className="grid gap-2 grid-cols-5">
                    {prodCodeData &&
                      !isSearch &&
                      prodCodeData.map((x) => {
                        const producerCode = x.producerCode
                          ? x.producerCode
                          : null;
                        const mAproducerCode = x.mAproducerCode
                          ? x.mAproducerCode
                          : null;
                        const codes = producerCode ?? mAproducerCode ?? "";
                        return (
                          <div
                            key={x.carrierProducerCodeId}
                            className="bg-white border border-gray-200 w-full shadow-md rounded-md"
                          >
                            <div className="flex p-2">
                              <div className="translate-y-4">
                                <QrCodeIcon className="text-blue-500 h-8 w-8" />
                              </div>
                              <div className="text-gray-600 font-medium ml-2 truncate ">
                                <h3 className="text-xs1 flex items-center font-normal text-gray-400">
                                  <svg
                                    className={
                                      x.isActive
                                        ? "text-green-500 mr-1 talic h-2 w-2"
                                        : "text-gray-40 mr-1 talic h-2 w-2"
                                    }
                                    fill="currentColor"
                                    viewBox="0 0 8 8"
                                  >
                                    <circle cx={4} cy={4} r={3} />
                                  </svg>{" "}
                                  {x.isActive ? "Active" : "Inactive"}
                                </h3>
                                <h1
                                  className="tileClasses"
                                  onClick={() => {
                                    handleHyperlink(x);
                                  }}
                                >
                                  {codes}
                                </h1>
                                {!x.producerCode && (
                                  <h2 className="text-xxs font-medium text-gray-400">
                                    {"MA Codes"}
                                  </h2>
                                )}
                                <h2 className="text-xs font-medium text-gray-700 mt-1">
                                  {x.carrierName
                                    ? x.carrierName
                                    : "unspecified"}
                                </h2>
                                <h2 className="text-xxs font-medium text-gray-400">
                                  {"Employee"}
                                </h2>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    {isSearch &&
                      filteredProdCode?.map((x) => {
                        const producerCode = x.producerCode
                          ? x.producerCode
                          : null;
                        const mAproducerCode = x.mAproducerCode
                          ? x.mAproducerCode
                          : null;
                        const codes = producerCode ?? mAproducerCode ?? "";
                        return (
                          <div
                            key={x.carrierProducerCodeId}
                            className="bg-white border border-gray-200 w-full shadow-md rounded-md"
                          >
                            <div className="flex p-2">
                              <div className="translate-y-4">
                                <QrCodeIcon className="text-blue-500 h-8 w-8" />
                              </div>
                              <div className="text-gray-600 font-medium ml-2 truncate  ">
                                <h3 className="text-xs1 flex items-center font-normal text-gray-400">
                                  <svg
                                    className={
                                      x.isActive
                                        ? "text-green-500 mr-1 talic h-2 w-2"
                                        : "text-gray-40 mr-1 talic h-2 w-2"
                                    }
                                    fill="currentColor"
                                    viewBox="0 0 8 8"
                                  >
                                    <circle cx={4} cy={4} r={3} />
                                  </svg>{" "}
                                  {x.isActive ? "Active" : "Inactive"}
                                </h3>
                                <h1
                                  className="tileClasses"
                                  onClick={() => {
                                    handleHyperlink(x);
                                  }}
                                >
                                  {codes}
                                </h1>
                                {!x.producerCode && (
                                  <h2 className="text-xxs font-medium text-gray-400">
                                    {"MA Codes"}
                                  </h2>
                                )}
                                <h2 className="text-xs font-medium text-gray-700 mt-1">
                                  {x.carrierName
                                    ? x.carrierName
                                    : "unspecified"}
                                </h2>
                                <h2 className="text-xxs font-medium text-gray-400">
                                  {"Employee"}
                                </h2>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    {isSearch && filteredProdCode.length === 0 && (
                      <div className="flex pt-2 pb-5 items-center justify-center text-sm col-span-5">
                        No records to display
                      </div>
                    )}
                  </div>
                </div>
                <CloseIconButton onClick={closeFullView} />
                <div className="text-xs max-h-fit"></div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
